<div
  layout="column"
  layout-align="center center"
  flex=""
  style="
min-height: 40px;
"
>
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
